import { formatCurrency } from "@/lib/conversion-utils";

import {
  SCOUT_ATTRIBUTION_MONTHS,
  SCOUT_CAP_ACTIVITY_USD,
  SCOUT_CLAWBACK_DAYS,
  SCOUT_LIFETIME_CAP_USD,
  SCOUT_RATE,
} from "./scout-data";

const CAP = formatCurrency(SCOUT_LIFETIME_CAP_USD);
const CAP_ACTIVITY = formatCurrency(SCOUT_CAP_ACTIVITY_USD);

export const scoutFaqs = [
  {
    question: "What counts as a qualified referral?",
    answer: `A business you introduce through your unique referral link, or register with our team before its first contact with Terac, that was not already a Terac customer or supplier, and that completes its first paid, approved transaction within ${SCOUT_ATTRIBUTION_MONTHS} months of your introduction.`,
  },
  {
    question: "Is there a cap on what I can earn per company?",
    answer: `Yes: ${CAP} per referred business, for the lifetime of the account. The cap does not reset. There is no limit on how many different businesses you can refer.`,
  },
  {
    question: "What's the commission rate?",
    answer: `${SCOUT_RATE}% of the referred business's net approved activity on Terac.`,
  },
  {
    question: "When and how am I paid?",
    answer: `Monthly, in USD, on verified net-collected activity, with a ${SCOUT_CLAWBACK_DAYS}-day clawback window covering refunds, reversals, and fraud. Clawed-back amounts are offset against future payouts.`,
  },
  {
    question: "How much can I realistically earn?",
    answer: `It depends entirely on how much the referred business transacts. Commissions are capped at ${CAP} per company, which a business reaches at roughly ${CAP_ACTIVITY} of activity. Results vary widely: many referred businesses generate far less than the cap, and a referral that never transacts earns nothing.`,
  },
  {
    question: "What kinds of introductions count?",
    answer:
      "Two: buyers (companies that purchase verified human work, like AI labs, research teams, and data buyers) and workforce partners (businesses that enroll their teams to complete paid work on Terac). Buyer commissions are based on net approved spend; workforce commissions on the net approved amounts Terac pays that business.",
  },
  {
    question: "Does this stack with Terac's individual referral program?",
    answer:
      "No. Each dollar of activity is commissioned under one Terac program only. Where more than one program could apply, Terac applies the single program most favorable to you.",
  },
  {
    question: "Who can refer, and how do taxes work?",
    answer:
      "Anyone 18 or older who can enter a contract, except where prohibited by law or sanctions. Current Terac employees and contractors cannot earn on referrals within the scope of their role. You participate as an independent contractor and are responsible for your own taxes: provide a W-9 (US) or W-8BEN / W-8BEN-E (non-US), and Terac issues forms such as a 1099-NEC where required.",
  },
  {
    question: "What should I avoid?",
    answer:
      "Don't misrepresent Terac, promise earnings or acceptance, spam communities, or refer businesses without their knowledge and consent. If you promote your referral link publicly, disclose that you are a paid Terac partner. If you have any relationship with a business you refer, disclose it and make sure the introduction complies with that business's policies.",
  },
];
